import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, VStack } from "@chakra-ui/react";
import { ROUTE_DASHBOARD } from "../navigation/routes";
import { useTranslation } from "react-i18next";
import FileStatusCard from "../components/status/FileStatusCard";

/**
 * Renders the beneficiary file status page
 * 
 * @returns The beneficiary file status page
 */
const BeneficiaryFileStatusPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  /**
   * Navigates to the dashboard page
   */
  const onGoHome = useCallback(() => {
    navigate(ROUTE_DASHBOARD);
  }, [navigate]);

  return (
    <VStack alignItems={"stretch"} flexGrow={1} gap={4} marginX={4}>
      <FileStatusCard />
      <Button
        alignSelf={"flex-start"}
        onClick={onGoHome}
        size={"md"}
        type={"submit"}
        variant={"secondary"}
      >
        {t("beneficiaryFileStatus.home")}
      </Button>
    </VStack>
  );
};

export default React.memo(BeneficiaryFileStatusPage);
